import React from 'react'
import { TextContent } from '../../../../shared/TextContent/TextContent'
import Endpoints from '../../../../shared/Endpoints/Endpoints'
import Stepper from "../../../../shared/Stepper/Stepper"
import { ThirdPartyAccessData } from "../../../../constants/StepperData"
import CodeBlock from '../../../../shared/CodeBlock/CodeBlock'
import SupportedDataAccess from '../StepComponents/SupportedDataAccess'

function ThirdPartyAccess() {

    return (
        <section className="subgroup" id="third-party-access-section">
            <TextContent
                header={"Third Party Access"}
                description={"Request FHIR Data through our FHIR API as a Third Party"} />
            <div className="step-container">
                <div className="number-and-title">
                    <h2 className="step-number">1</h2>
                    <h2 className="step-title">Registration</h2>
                </div>
                <ul className='step-content'>
                    <li>
                        <p>Reach out to the Interoperability Operations team to initiate onboarding as a third party application </p>
                    </li>
                    <li>
                        <p>
                            Complete the registration form provided by Elevance Health
                        </p>
                    </li>
                    <li>
                        <p>
                            Receive the credentials to establish a connection with us
                        </p>
                    </li>
                </ul>
            </div>
            <SupportedDataAccess
                accessType={"thirdParty"}
                stepNumber={2} />
        </section>
    )
}

export default ThirdPartyAccess